import React from 'react';

const DataCollection = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        We collect various types of information to provide and improve our services. This includes:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Personal information (name, email, contact details)</li>
        <li>Usage data (how you interact with our services)</li>
        <li>Device information (browser type, IP address)</li>
        <li>Content you create or share through our platform</li>
      </ul>
    </div>
  );
};

export default DataCollection;